module.exports = __webpack_public_path__ + "img/goods_m.0a508742.png";